<script setup>
import { onMounted, provide, ref } from 'vue'
import BasicLayout from '@/components/ui/layouts/BasicLayout.vue'
import TopBarUser from '@/components/ui/topbar/TopBarUser.vue'
import SidebarMenu from '@/components/ui/sidebar/SidebarMenu.vue'

const menuVisible = ref(false)
const topBarComponent = ref(null)

onMounted(() => {
  provide('menuRef', topBarComponent.value.navMenuButton)
})

function toggleMenuVisibility() {
  menuVisible.value = !menuVisible.value
}
</script>

<template>
  <basic-layout>
    <template #topbar>
      <top-bar-user
        @togglemenu="toggleMenuVisibility"
        ref="topBarComponent"
      />
    </template>
    <template #sidebar>
      <sidebar-menu v-model="menuVisible" />
    </template>
    <app-panel>
      <slot />
    </app-panel>
  </basic-layout>
</template>
